<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M6.74,24h10.5A6.76,6.76,0,0,0,24,17.25V6.75A6.76,6.76,0,0,0,17.24,0H6.74A6.76,6.76,0,0,0,0,6.75v10.5A6.76,6.76,0,0,0,6.74,24ZM1.49,6.75A5.26,5.26,0,0,1,6.74,1.5h10.5a5.26,5.26,0,0,1,5.25,5.25v10.5a5.26,5.26,0,0,1-5.25,5.25H6.74a5.26,5.26,0,0,1-5.25-5.25Z"/><path d="M12,17.75A5.75,5.75,0,1,0,6.24,12,5.76,5.76,0,0,0,12,17.75Zm0-10A4.25,4.25,0,1,1,7.74,12,4.26,4.26,0,0,1,12,7.75Z"/><circle cx="18.84" cy="5.15" r="1.25"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'social-instagram',
    },
    name: {
      type: String,
      required: false,
      default: 'SocialInstagram',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>